import React from 'react';
import PropTypes from 'prop-types';

import 'bloko/blocks/modal/modal.less';

/**
 * Подвал модального окна
 */
export default function ModalFooter({ ...modalFooterProps }) {
    return <div {...modalFooterProps} className="bloko-modal-footer" />;
}

ModalFooter.propTypes = {
    /** Контент */
    children: PropTypes.node,
};
